module.exports = __webpack_public_path__ + "static/img/banner.619e7d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = 404
// module chunks = 1